var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"items":_vm.breadcrumbItems,"hasBreadcrumb":"","hasBackButton":""}}),_c('form',[_c('b-card',{staticClass:"mc-card__setting"},[_c('b-tabs',{attrs:{"content-class":"p-3 text-muted","nav-wrapper-class":"mc-tab"}},[(
            _vm.hasAccessAll([
              'company_structure:read',
              'company_structure:create',
              'company_structure:update',
              'company_structure:delete',
              'c2a-default-setkaryawan:read',
            ])
          )?_c('Department',{key:_vm.departmentKey,ref:"department",attrs:{"status":"Department"}}):_vm._e(),(
            _vm.hasAccessAll([
              'company_structure:read',
              'company_structure:create',
              'company_structure:update',
              'company_structure:delete',
              'c2a-default-setkaryawan:read',
            ])
          )?_c('Unit',{key:_vm.unitKey,ref:"empUnit",attrs:{"status":"Unit"},on:{"refresh-component-dept":_vm.refreshComponentDepartment}}):_vm._e(),(
            _vm.hasAccessAll([
              'company_structure:read',
              'company_structure:create',
              'company_structure:update',
              'company_structure:delete',
              'c2a-default-setkaryawan:read',
            ])
          )?_c('Position',{ref:"empPos",attrs:{"status":"Position"},on:{"refresh-component-unit":_vm.refreshComponentUnit}}):_vm._e(),(
            _vm.hasAccessAll([
              'employee_recruited_at:read',
              'employee_recruited_at:create',
              'employee_recruited_at:update',
              'employee_recruited_at:delete',
              'c2a-default-setkaryawan:read',
            ])
          )?_c('Recruitment',{ref:"empRecruitment",attrs:{"status":"Recruitment"}}):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }